import type { FunctionComponent, PropsWithChildren } from 'react';

import styles from './loader.module.css';

// TODO: loader sounds like it's purpose is to load something. Rename maybe? Usually these things are called "spinners"
export const Loader: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.loader__container}>
      <div className={styles.loader}></div>
      {children ? <div className={styles.loader__content}>{children}</div> : null}
    </div>
  );
};
